import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronRight } from 'lucide-react'; 
import OptimizedImageByName from '../common/OptimizedImageByName';

export const FruitsSection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section className="px-6 py-12 bg-gradient-to-b from-amber-100 to-orange-100">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-6">
          <h2 className="text-4xl font-bold text-black mb-6 leading-tight">
            {t('fruits.section.mainTitle', 'Healthy vibes with every juicy bite.')}
          </h2>
          <p className="text-md text-gray-600">
            {t('fruits.section.subtitle', 'Seasonal fruits delivered to your door weekly.')}
          </p>
        </div>

        {/* Fruit Image */}
        <div className="rounded-2xl shadow-lg overflow-hidden mb-6 aspect-[4/3]">
          <OptimizedImageByName 
            imageName="fruitsSection" 
            alt={t('fruits.section.imageAlt', 'Fresh seasonal fruits collection')}
            className="w-full h-full object-cover scale-125"
          />
        </div>

        {/* Coming Soon Banner */}
        {/* <div className="bg-gradient-to-r from-yellow-200 to-orange-200 rounded-2xl p-6 text-center shadow-lg">
          <div className="bg-white bg-opacity-80 rounded-xl py-4 px-8 inline-block">
            <p className="text-xl font-semibold text-gray-800">
              {t('fruits.section.comingSoon', 'Coming soon')}
            </p>
          </div>
        </div> */}

        {/* Optional: Keep explore button for navigation */}
        <div className="text-center mt-8">
          <button
            onClick={() => navigate('/fruits')}
            className="inline-flex items-center space-x-2 bg-orange-400 text-white px-16 py-4 rounded-full hover:bg-orange-600 transition-colors font-medium transform hover:-translate-y-0.5 transition-all border-none"
          >
            <span>{t('fruits.section.exploreButton', 'Explore Fruits')}</span>
          </button>
        </div>
      </div>
    </section>
  );
}; 